import { useState } from "react";
import { X, Trash2 } from "lucide-react";
import toast from "react-hot-toast";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";

const DeleteEvent = ({ event, onClose, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (!event?.id) {
      toast.error("Unable to determine event to delete.");
      return;
    }

    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.error("Authentication required. Please sign in again.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${BASE_URL}${API_ENDPOINTS.NONPROFIT_DELETE_EVENT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ eventId: event.id }),
      });

      const result = await response.json().catch(() => null);
      const statusCode = result?.statusCode ?? response.status;

      if (!response.ok || statusCode >= 400) {
        throw new Error(result?.message || "Failed to delete event.");
      }

      toast.success("Event deleted successfully.");
      onSuccess?.();
    } catch (error) {
      toast.error(error?.message || "Failed to delete event.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!event) {
    return null;
  }

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-50 transition-opacity"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className="rounded-lg overflow-hidden shadow-2xl w-[80%] lg:w-[22%] bg-white">
          <div className="flex items-center justify-between p-6 text-black">
            <h2 className="text-lg lg:text-xl font-popinsSemiBold">Delete Event</h2>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          <div className="px-6 pb-6">
            <div className="flex justify-center mb-4">
              <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
                <Trash2 className="w-7 h-7 text-red-500" />
              </div>
            </div>
            <p className="font-popinsRegular text-base text-center">
              Are you sure you want to delete&nbsp;
              <span className="font-popinsSemiBold text-black">{event.title}</span>?
            </p>
            <div className="flex justify-end gap-x-3 mt-8">
              <button
                type="button"
                className="relative overflow-hidden py-3 px-8 bg-[#F0F2F5] text-black font-popinsSemiBold text-sm rounded-md shadow-lg transform transition duration-300 ease-in-out hover:bg-[#F0F2F5]/90 hover:scale-105 active:scale-95 active:shadow-inner focus:outline-none disabled:opacity-50"
                onClick={onClose}
                disabled={isSubmitting}
              >
                No
                <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
              </button>
              <button
                type="button"
                className="relative overflow-hidden py-3 px-8 bg-red-500 text-white font-popinsSemiBold text-sm rounded-md shadow-lg transform transition duration-300 ease-in-out hover:bg-red-500/90 hover:scale-105 active:scale-95 active:shadow-inner focus:outline-none disabled:opacity-50"
                onClick={handleDelete}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Deleting..." : "Yes"}
                <span className="absolute inset-0 rounded-full bg-white opacity-0 active:opacity-10 transition-opacity duration-300"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteEvent;
